import { DropdownContainer } from '@lib/components'
import { Check } from '@lib/icons'
import cx from 'classnames'
import type React from 'react'

import cssPublish from '../../Publish.module.scss'
import css from './SettingsDropdown.module.scss'

type Props = {
  settingsName: string
  items: { id: string; name: string }[]
  activeItem: { id: string; name: string }
  onChange: (data: { id: string; name: string }) => void
}

export const SettingsDropdown: React.FC<Props> = ({
  settingsName,
  items,
  activeItem,
  onChange,
}) => {
  return (
    <div>
      <div className={css.wrap}>
        {settingsName}
        <DropdownContainer
          position="bottom-end"
          offset={{ x: 2 }}
          renderButton={(onSetRef, onClick, isOpen) => (
            <div
              ref={onSetRef}
              className={cx(css.button, {
                [css.active]: isOpen,
              })}
              onClick={onClick}
            >
              {activeItem.name}
              <i className={cx(css.fa, 'fa fa-chevron-down')} />
            </div>
          )}
        >
          {(closeDropdown) =>
            items.map((item) => (
              <button
                key={item.id}
                className={css.dropdownItem}
                onClick={() => {
                  closeDropdown()
                  onChange({ id: item.id, name: item.name })
                }}
              >
                {item.name}
                {item.id === activeItem.id && (
                  <Check size={16} left={0} className={css.checkIcon} />
                )}
              </button>
            ))
          }
        </DropdownContainer>
      </div>
      <div className={cssPublish.divider} />
    </div>
  )
}
